/**
 * useCliente — F-012 Phase 3 (IMPL-P3-003).
 *
 * TanStack Query hook for a single business-account detail (account + wallet
 * stats + audit trail). Disabled when `id` is falsy so the detail page can call
 * it unconditionally (Rules of Hooks) while `useParams()` resolves.
 *
 * Pattern: `features/archivio/hooks/usePraticaDetail.ts`.
 */
import { useQuery } from '@tanstack/react-query';

import { getCliente, type ClienteDetailView } from '../lib/admin-client';

export function useCliente(id: string | undefined) {
  return useQuery<ClienteDetailView>({
    queryKey: ['admin', 'cliente', id],
    queryFn: () => getCliente(id as string),
    enabled: Boolean(id),
  });
}
